import React from "react";
const TwitterIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M4.09856 4.06761L8.70069 10.6118L4.06915 15.9324H5.1118L9.16634 11.2744L12.4429 15.9324H15.9905L11.1293 9.02057L15.4405 4.06846H14.3979L10.6635 8.35888L7.64608 4.06846H4.09856V4.06761ZM5.63154 4.88395H7.26145L14.4575 15.1152H12.8275L5.63154 4.88395Z",
    fillRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1_2" }, /* @__PURE__ */ React.createElement("rect", { width: "12", height: "12", fill: "white", transform: "translate(4 4)" }))));
var TwitterIcon_default = TwitterIcon;
export {
  TwitterIcon_default as default
};
//# sourceMappingURL=TwitterIcon.js.map
